// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/view-columns.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/view-columns'

import { Icon, type IconComponentProps } from '../icon'

export const ViewColumnsIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
